const initMiniCart = () => {
  const miniCart = document.querySelector('[data-mini-cart]');
  const panel = miniCart?.querySelector('[data-mini-cart-panel]');
  const toggles = Array.from(document.querySelectorAll('[data-cart-toggle]'));
  const closeButtons = Array.from(
    miniCart?.querySelectorAll('[data-cart-close]') || []
  );

  if (!miniCart || !panel || !toggles.length) return;

  let returnFocus = null;

  const syncProductCardStates = () => {
    const productIds = new Set(
      Array.from(
        miniCart.querySelectorAll('.remove_from_cart_button[data-product_id]')
      ).map((button) => button.dataset.product_id)
    );

    document
      .querySelectorAll('.product-card__cart[data-product_id]')
      .forEach((button) => {
        const isAdded = productIds.has(button.dataset.product_id);

        button.classList.toggle('is-added', isAdded);
        button.classList.toggle('added', isAdded);
        button.setAttribute(
          'aria-label',
          isAdded ? button.dataset.addedLabel : button.dataset.defaultLabel
        );
      });
  };

  const focusableElements = () =>
    Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden && element.offsetParent !== null);

  const open = (trigger = null) => {
    returnFocus = trigger || document.activeElement;
    miniCart.inert = false;
    miniCart.setAttribute('aria-hidden', 'false');
    miniCart.classList.add('is-open');
    document.body.classList.add('mini-cart-open');
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));

    window.requestAnimationFrame(() => {
      focusableElements()[0]?.focus();
    });
  };

  const close = () => {
    if (!miniCart.classList.contains('is-open')) return;

    miniCart.classList.remove('is-open');
    miniCart.inert = true;
    miniCart.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mini-cart-open');
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));

    if (returnFocus instanceof HTMLElement) returnFocus.focus();
    returnFocus = null;
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => open(toggle));
  });
  closeButtons.forEach((button) => button.addEventListener('click', close));

  document.addEventListener('keydown', (event) => {
    if (!miniCart.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = focusableElements();

    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  $(document.body).on('adding_to_cart', (event, button) =>
    button?.addClass('is-adding')
  );

  $(document.body).on('added_to_cart', (event, fragments, hash, button) => {
    const element = button?.get(0);

    button?.removeClass('is-adding').addClass('is-added');
    element?.setAttribute('aria-label', element.dataset.addedLabel || '');
    document
      .querySelectorAll('.product-card a.added_to_cart.wc-forward')
      .forEach((link) => link.remove());
    window.setTimeout(syncProductCardStates, 0);
    open(element || null);
  });

  $(document.body).on(
    'wc_fragments_loaded wc_fragments_refreshed removed_from_cart',
    () => {
      document
        .querySelectorAll('.product-card a.added_to_cart.wc-forward')
        .forEach((link) => link.remove());
      syncProductCardStates();
    }
  );

  syncProductCardStates();
};

document.addEventListener('DOMContentLoaded', initMiniCart);
